/* eslint-disable no-shadow */
enum ClaimTypes {
  aud = 'aud',
  exp = 'exp',
  iss = 'iss',
  role = 'role',
  action = 'action',
  user_id = 'user_id',
  user_type = 'user_type',
  domainName = 'domainName',
  hierarchy_levels = 'hierarchy_levels',
  access_profile_id = 'access_profile_id',
}
export default ClaimTypes;

